module.exports = __webpack_public_path__ + "img/img2.bb9f85fc.png";